var _defs, _rect, _text, _text2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _path8, _rect2, _g, _path9, _path0, _path1, _polygon2, _polygon3, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _line, _line2, _line3, _polygon4, _path18, _path19, _path20, _rect3, _path21, _polygon5, _rect4, _rect5, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _path22, _path23, _rect6, _rect7, _path24, _path25, _g2, _path26, _line33, _line34, _line35, _line36, _path27, _path28, _path29, _path30, _rect8, _polygon6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigitalmarketingtab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765 277",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-10,.cls-13,.cls-16,.cls-18,.cls-20,.cls-21,.cls-22,.cls-23,.cls-25,.cls-7{fill:none;}.cls-2{fill:#d8c4df;}.cls-3{font-size:45px;}.cls-3,.cls-4,.cls-8{fill:#2f2143;}.cls-3,.cls-4{font-family:CenturyGothic-Bold, Century Gothic;font-weight:700;}.cls-4{font-size:35px;}.cls-5{fill:#e5ac24;}.cls-6{fill:#2e1f42;}.cls-7{stroke:#4f4e4f;stroke-width:0.23px;}.cls-10,.cls-13,.cls-16,.cls-18,.cls-20,.cls-21,.cls-22,.cls-23,.cls-25,.cls-7{stroke-miterlimit:10;}.cls-9{fill:#fff;}.cls-10{stroke:#7a797b;stroke-width:0.26px;}.cls-11{opacity:0.5;}.cls-12{clip-path:url(#clip-path);}.cls-13,.cls-16,.cls-25{stroke:#2f2143;}.cls-13{stroke-width:0.53px;}.cls-14{fill:#cd922a;}.cls-15{fill:#8e8b8c;}.cls-16,.cls-18{stroke-width:0.48px;}.cls-17{fill:#9a499c;}.cls-18{stroke:#fff;stroke-linecap:round;stroke-dasharray:2.03 2.03;}.cls-19{fill:#f7f7f7;}.cls-20,.cls-21,.cls-22{stroke:#e5ac24;}.cls-20{stroke-width:0.56px;}.cls-21{stroke-width:0.53px;}.cls-22{stroke-width:0.51px;}.cls-23{stroke:#9a499c;stroke-width:0.61px;}.cls-24{clip-path:url(#clip-path-2);}.cls-25{stroke-width:1.57px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 88.2,
    y: 47.24,
    width: 28.92,
    height: 11.42
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 509.63,
    y: 31.69,
    width: 26.89,
    height: 23.93,
    transform: "translate(18.35 187.75) rotate(-20.7)"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "digital marketing tab") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 765,
    height: 277
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(294 163.76)"
  }, "DIGITAL")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(281.68 196.28)"
  }, "MARKETING")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M202.56,200.84l11.53,4.78a8.91,8.91,0,0,0,11.65-4.82l.23-.56a8.91,8.91,0,0,0-4.82-11.65l-11.53-4.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.56,183.82c-4.33,10.46-11.49,17.43-16,15.57s-4.61-11.85-.28-22.31,11.49-17.44,16-15.58,4.62,11.86.28,22.32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M170.11,199.61l32.45,1.23,7.06-17-23.81-22.09a34.33,34.33,0,0,1-15.7,37.89"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M209.62,183.81s4.85,7.88-7.06,17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M214.09,205.62S199.54,221,201.5,231.33L191,227s10.86-10.82,13.15-25.47Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71.23,164.33H33.32a1.82,1.82,0,0,1-1.82-1.83V142.93a1.82,1.82,0,0,1,1.82-1.83H71.23a1.83,1.83,0,0,1,1.83,1.83V162.5a1.83,1.83,0,0,1-1.83,1.83"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M70.1,163.31H34.35a1.83,1.83,0,0,1-1.83-1.83V144a1.83,1.83,0,0,1,1.83-1.83H70.1A1.83,1.83,0,0,1,71.93,144v17.53a1.83,1.83,0,0,1-1.83,1.83"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "55.1 152.7 50.6 150.1 50.6 155.3 55.1 152.7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M56.09,152.71a4,4,0,1,1-4-4A4,4,0,0,1,56.09,152.71Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 32.52,
    y: 159.5,
    width: 39.4,
    height: 0.89
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M88.59,53.62l8.54,4.93a.77.77,0,0,0,1.16-.67V48a.77.77,0,0,0-1.16-.67l-8.54,4.94a.77.77,0,0,0,0,1.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 98.29,
    y: 50.31,
    width: 18.83,
    height: 5.27
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M163.35,164.72s-14.12,4.06-10.13,19.13"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M160.68,156.89s-19.63,5.65-14.09,26.6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M158.23,149.48S132.09,157,139.47,184.9"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "234.26 95.61 262.8 106.92 248.78 115.68 234.26 95.61"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "234.26 95.61 255.69 111.44 255.69 117.09 258.47 110.35 234.26 95.61"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M244.11,62.21H231.74a1.66,1.66,0,0,1-1.66-1.66V33.92a1.65,1.65,0,0,1,1.66-1.65h12.37a1.65,1.65,0,0,1,1.66,1.65V60.55a1.66,1.66,0,0,1-1.66,1.66"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M243.36,60.77H232.49a1.66,1.66,0,0,1-1.66-1.66V35.36a1.66,1.66,0,0,1,1.66-1.66h10.87A1.66,1.66,0,0,1,245,35.36V59.11a1.66,1.66,0,0,1-1.66,1.66"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M238.86,59.29a.94.94,0,1,1-.94-.94.94.94,0,0,1,.94.94"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M239,35h-2.74a.35.35,0,0,1-.35-.34.35.35,0,0,1,.35-.35H239a.35.35,0,0,1,.34.35A.34.34,0,0,1,239,35"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M23.81,208.48c.17-.43.34-.86.52-1.29A19.19,19.19,0,0,1,28.45,201l3.23-3.25a.78.78,0,0,1,.51-.21c2,0,3.91,0,5.86,0a.73.73,0,0,1,.59.23c1.41,1.46,2.91,2.86,4.25,4.39a18,18,0,0,1,4.24,9.22,26.45,26.45,0,0,1,.23,2.95,4,4,0,0,0,1.57,3.1,4,4,0,0,1,1.54,2.22,3.05,3.05,0,0,1,0,1.72,2,2,0,0,1-1.78,1.34c-1.3,0-2.59,0-3.88,0,0,0-3.64,0-10.86,0-4.62,0-8.27.78-12,.11-.82-.15-2.2-.46-2.69-1.52a2.28,2.28,0,0,1,.13-2.12c.61-.94,1.6-.54,2.25-1.46.43-.62.15-1,.47-2.38a8,8,0,0,1,.78-2m12.28-12.51c0-.7,0-1.4,0-2.1,0-.11,0-.28-.11-.33a.45.45,0,0,0-.71.42c0,1.34,0,2.68,0,4,0,.33-.05.5-.43.55a5,5,0,0,0-1.2.35,6.48,6.48,0,0,0-.91,11.57,6.6,6.6,0,0,0,.92.47,7.73,7.73,0,0,0,2.64.49,6.06,6.06,0,0,0,6.26-6.77A6.91,6.91,0,0,0,41.4,208,6.69,6.69,0,0,0,40,205.44a5.89,5.89,0,0,0-1-1,6.91,6.91,0,0,0-3.47-1.26c-.26,0-.36-.1-.36-.37,0-.69,0-1.37,0-2.06"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M36,190.26c.26-.51.48-1,.73-1.42a1.39,1.39,0,0,1,.3-.21,3.93,3.93,0,0,1,2.83-.23,2.61,2.61,0,0,1,1.15.54,2.15,2.15,0,0,1,.5.63,1.71,1.71,0,0,1-.16,1.84c-.78,1-1.62,2-2.37,3a1.51,1.51,0,0,1-1.45.68c-1.77-.06-3.53,0-5.3-.07a.65.65,0,0,1-.44-.2c-.89-1.09-1.78-2.19-2.63-3.3a1.76,1.76,0,0,1,.92-2.88,2.25,2.25,0,0,1,.49,0c1-.06,1.1-.32,1.83-.34a4.48,4.48,0,0,1,1.69.34,1.23,1.23,0,0,1,.48.2c.48.45.94.93,1.43,1.43"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M37.57,197.06H36.42c-.25,0-.42-.1-.41-.37a.35.35,0,0,1,.4-.38h2.31c.26,0,.47.11.46.4s-.22.35-.46.35H37.57"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.82,212.18h1.12a.78.78,0,0,0,.84-.83.77.77,0,0,0-.82-.81c-.65,0-1.3,0-2-.06a2.4,2.4,0,0,1-.11-4.74c.26,0,.47-.07.54-.41s.38-.44.72-.44a.66.66,0,0,1,.72.49c.07.28.22.31.45.3a2,2,0,0,1,.55,0,.78.78,0,0,1-.1,1.55c-.78,0-1.56,0-2.34,0-.62,0-.94.34-.91.9a.68.68,0,0,0,.63.72c.66.05,1.32,0,2,.07a2.2,2.2,0,0,1,1.72.88,2.38,2.38,0,0,1,.33,2.47,2.26,2.26,0,0,1-1.95,1.44c-.18,0-.29.06-.34.27a.74.74,0,0,1-.74.57.73.73,0,0,1-.75-.56c-.06-.2-.15-.27-.34-.26h-.53a.75.75,0,0,1-.8-.75.77.77,0,0,1,.72-.82l.11,0h1.25"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 16.94,
    y1: 76.21,
    x2: 39.65,
    y2: 66.29
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 24.36,
    y1: 75.21,
    x2: 47.08,
    y2: 65.29
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 23.91,
    y1: 70.69,
    x2: 46.62,
    y2: 60.77
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "132.74 99.61 136.09 97.84 135.44 101.57 138.16 104.22 134.41 104.76 132.74 108.15 131.06 104.76 127.32 104.22 130.03 101.57 129.39 97.84 132.74 99.61"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M15.91,267.7a68,68,0,0,1,17.22-25.44c13.93-12.71,31.4-17.13,52.83-18.39,59.29-3.48,70.29,21.9,107.21,15.26,41.4-7.44,82.61-49.25,79.83-88.83-1-14.58-7.86-26.46-14.54-35"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M721.21,215.18h-158A6.2,6.2,0,0,1,557,209V118.52a6.2,6.2,0,0,1,6.18-6.18h158a6.2,6.2,0,0,1,6.18,6.18V209a6.2,6.2,0,0,1-6.18,6.18"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M717.4,207.77H567.28a5.58,5.58,0,0,1-5.57-5.56V125.32a5.59,5.59,0,0,1,5.57-5.57H717.4a5.59,5.59,0,0,1,5.57,5.57v76.89a5.58,5.58,0,0,1-5.57,5.56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 561.71,
    y: 126.28,
    width: 161.25,
    height: 5.93
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M683.21,244c0,2.51-19.37,4.54-43.25,4.54s-43.26-2-43.26-4.54,19.37-4.54,43.26-4.54,43.25,2,43.25,4.54"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "626.65 215.18 612.93 244.02 666.98 244.02 653.67 215.18 626.65 215.18"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 621.83,
    y: 137.17,
    width: 40.76,
    height: 32.63
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 670.83,
    y: 137.17,
    width: 37.64,
    height: 32.78
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 138.97,
    x2: 614.25,
    y2: 138.97
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 142.79,
    x2: 614.25,
    y2: 142.79
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 146.61,
    x2: 614.25,
    y2: 146.61
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 150.43,
    x2: 614.25,
    y2: 150.43
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 154.25,
    x2: 614.25,
    y2: 154.25
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 158.07,
    x2: 614.25,
    y2: 158.07
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 161.89,
    x2: 614.25,
    y2: 161.89
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 165.71,
    x2: 614.25,
    y2: 165.71
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 169.53,
    x2: 614.25,
    y2: 169.53
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 173.35,
    x2: 614.25,
    y2: 173.35
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 177.17,
    x2: 614.25,
    y2: 177.17
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 180.99,
    x2: 614.25,
    y2: 180.99
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 184.81,
    x2: 614.25,
    y2: 184.81
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 188.63,
    x2: 614.25,
    y2: 188.63
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 192.45,
    x2: 614.25,
    y2: 192.45
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 196.28,
    x2: 614.25,
    y2: 196.28
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 568.55,
    y1: 200.1,
    x2: 614.25,
    y2: 200.1
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 621.82,
    y1: 177.17,
    x2: 662.59,
    y2: 177.17
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 621.82,
    y1: 180.99,
    x2: 662.59,
    y2: 180.99
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 621.82,
    y1: 184.81,
    x2: 662.59,
    y2: 184.81
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 621.82,
    y1: 188.63,
    x2: 662.59,
    y2: 188.63
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 621.82,
    y1: 192.45,
    x2: 662.59,
    y2: 192.45
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 621.82,
    y1: 196.28,
    x2: 662.59,
    y2: 196.28
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 621.82,
    y1: 200.1,
    x2: 662.59,
    y2: 200.1
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 670.83,
    y1: 177.17,
    x2: 709.14,
    y2: 177.17
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 670.83,
    y1: 180.99,
    x2: 709.14,
    y2: 180.99
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 670.83,
    y1: 184.81,
    x2: 709.14,
    y2: 184.81
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 670.83,
    y1: 188.63,
    x2: 709.14,
    y2: 188.63
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 670.83,
    y1: 192.45,
    x2: 709.14,
    y2: 192.45
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 670.83,
    y1: 196.28,
    x2: 709.14,
    y2: 196.28
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 670.83,
    y1: 200.1,
    x2: 709.14,
    y2: 200.1
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M406.83,62.94a17.22,17.22,0,1,1-17.22-17.21,17.22,17.22,0,0,1,17.22,17.21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M385,79.55V67.45h-3.76v-5.6H385V57.57s0-9.65,13-6.86v5l-3.53.13s-3.18-.39-2.73,6h6l-1,5.63-5,0V80.09a20.05,20.05,0,0,1-6.6-.54"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 475.41,
    y: 94.4,
    width: 28.18,
    height: 28.18,
    rx: 5.3
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 480.09,
    y: 99.08,
    width: 18.82,
    height: 18.82,
    rx: 5.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M492.91,108.49a3.42,3.42,0,1,1-3.41-3.42A3.41,3.41,0,0,1,492.91,108.49Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M496.56,102.22a1.08,1.08,0,1,1-1.07-1.07,1.07,1.07,0,0,1,1.07,1.07"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M514.73,59.6a13.44,13.44,0,0,1,25.15-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M525.6,35.52a5.24,5.24,0,1,1-6.75-3.05,5.24,5.24,0,0,1,6.75,3.05"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M649.38,80.13a3.91,3.91,0,1,1-5.28-1.65,3.93,3.93,0,0,1,5.28,1.65"
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 646.73,
    y1: 78.12,
    x2: 651.65,
    y2: 57.69
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 652.03,
    y1: 57.61,
    x2: 672.39,
    y2: 62.83
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 681.21,
    y1: 42.21,
    x2: 676.29,
    y2: 62.65
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-25",
    x1: 681.75,
    y1: 40.49,
    x2: 702.67,
    y2: 42.48
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M655.24,55.38A3.91,3.91,0,1,1,650,53.73a3.92,3.92,0,0,1,5.28,1.65"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M678.4,61.67A3.92,3.92,0,1,1,673.12,60a3.92,3.92,0,0,1,5.28,1.66"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M685.13,38.52a3.91,3.91,0,1,1-5.28-1.66,3.9,3.9,0,0,1,5.28,1.66"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M707.46,39.45a3.91,3.91,0,1,1-5.41,1.16,3.92,3.92,0,0,1,5.41-1.16"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 476.09,
    y: 244.98,
    width: 33.65,
    height: 20.96
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "476.09 244.98 492.91 255.47 509.74 244.98 476.09 244.98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalmarketingtab);
export default __webpack_public_path__ + "static/media/digital marketing tab.7ea1969f0e1577bf49bb9fd61608f4e9.svg";
export { ForwardRef as ReactComponent };